import { NotificationTypes } from '@dynamika-shared/types/subscription';
import { TeamRoles } from 'src/constants/rolesList';
import {
  NotificationDeliveryStatus,
  NotificationRecipientType,
} from '@restore/clinicalTrialNotificationHistory/clinicalTrialNotificationHistory.types';

export { NotificationRecipientType };

export const notificationTypesDescriptions = {
  [NotificationTypes.UPLOAD_COMPLETED]: 'Image upload finished',
  [NotificationTypes.READY_FOR_READING]: 'Visit ready for reader workflow',
  [NotificationTypes.VISIT_COMPLETED]: 'Visit marked as completed',
  [NotificationTypes.READING_COMPLETED]: 'All required reads finished',
  [NotificationTypes.REPORT_RELEASED]: 'PDF report available',
  [NotificationTypes.SUBJECT_COMPLETED]: 'Subject workflow finished',
  [NotificationTypes.VALIDATION_COMPLETED]: 'After HRpQCT validation',
  [NotificationTypes.QUERY_NOTIFICATION]: 'When query status changes',
};

export const notificationAllowedRoles: Record<NotificationTypes, TeamRoles[]> =
  {
    [NotificationTypes.UPLOAD_COMPLETED]: [
      TeamRoles.PROJECT_MANAGER,
      TeamRoles.IMAGING_SPECIALIST,
      TeamRoles.SITE,
      TeamRoles.SPONSOR,
      TeamRoles.VALIDATION_SPECIALIST,
    ],
    [NotificationTypes.READY_FOR_READING]: [
      TeamRoles.PROJECT_MANAGER,
      TeamRoles.READER,
    ],
    [NotificationTypes.VISIT_COMPLETED]: [
      TeamRoles.PROJECT_MANAGER,
      TeamRoles.SPONSOR,
    ],
    [NotificationTypes.SUBJECT_COMPLETED]: [
      TeamRoles.PROJECT_MANAGER,
      TeamRoles.SPONSOR,
    ],
    [NotificationTypes.READING_COMPLETED]: [
      TeamRoles.PROJECT_MANAGER,
      TeamRoles.EXTERNAL_USER,
    ],
    [NotificationTypes.REPORT_RELEASED]: [
      TeamRoles.PROJECT_MANAGER,
      TeamRoles.SITE,
      TeamRoles.SPONSOR,
    ],
    [NotificationTypes.QUERY_NOTIFICATION]: [
      TeamRoles.PROJECT_MANAGER,
      TeamRoles.SITE,
      TeamRoles.IMAGING_SPECIALIST,
      TeamRoles.SPONSOR,
    ],
    [NotificationTypes.VALIDATION_COMPLETED]: [
      TeamRoles.PROJECT_MANAGER,
      TeamRoles.IMAGING_SPECIALIST,
      TeamRoles.VALIDATION_SPECIALIST,
    ],
  };

export const RECIPIENT_TYPE_LABEL: Record<NotificationRecipientType, string> = {
  [NotificationRecipientType.USER]: 'System User',
  [NotificationRecipientType.EMAIL]: 'External User',
};

export const STATUS_LABEL: Record<NotificationDeliveryStatus, string> = {
  [NotificationDeliveryStatus.CREATED]: 'Created',
  [NotificationDeliveryStatus.SENT]: 'Sent',
  [NotificationDeliveryStatus.FAILED]: 'Failed',
};

export const STATUS_PILL_CLASS: Record<NotificationDeliveryStatus, string> = {
  [NotificationDeliveryStatus.SENT]: 'bg-honeydew text-yellowGreen',
  [NotificationDeliveryStatus.FAILED]: 'bg-seashell text-redOrange',
  [NotificationDeliveryStatus.CREATED]: 'bg-brightGray text-dimGray',
};
